import React from 'react';
import { CardHeader } from 'reactstrap';

type BillingHeaderProps = {
  invoiceTypes: any[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const BillingHeader: React.FC<BillingHeaderProps> = () => {
  return (
    <CardHeader className="bg-soft-light border-bottom p-4">
      <div className="d-flex align-items-center">
        <div className="avatar-sm bg-white shadow-sm rounded-circle p-2 me-3 d-flex align-items-center justify-content-center">
          <i className="ri-bill-line text-primary h2 m-0"></i>
        </div>
        <div>
          <h4 className="card-title mb-1 text-primary fw-bold">Nueva Factura</h4>
          <p className="text-muted mb-0">Complete la información para generar el comprobante</p>
        </div>
      </div>
    </CardHeader>
  );
};

export default BillingHeader;
